import { InternalReportType } from "../../../../api/tenantInternalReports";

export enum InternalReportGroup {
  RBI_FRAUD_RETURNS = "RBI_FRAUD_RETURNS",
}

interface InternalReportGroupConfigEntry {
  label: string;
  order: number;
}

export const INTERNAL_REPORTS_GROUP_CONFIG: Record<
  InternalReportGroup,
  InternalReportGroupConfigEntry
> = {
  [InternalReportGroup.RBI_FRAUD_RETURNS]: { label: "RBI Fraud Returns", order: 1 },
};

export interface InternalReportConfigEntry {
  id: InternalReportType;
  title: string;
  description: string;
  tags: string[];
  group: InternalReportGroup;
  route: string;
}

export const INTERNAL_REPORT_CONFIG: Record<
  InternalReportType,
  InternalReportConfigEntry
> = {
  [InternalReportType.BORROWAL_VS_NON_BORROWAL]: {
    id: InternalReportType.BORROWAL_VS_NON_BORROWAL,
    title: "Borrowal & Non-Borrowal Cases by Amount Bucket",
    description:
      "Month-wise and cumulative fraud cases grouped by amount bucket.",
    tags: ["RBI"],
    group: InternalReportGroup.RBI_FRAUD_RETURNS,
    route: "/internal-reports/borrowal-vs-non-borrowal",
  },
  [InternalReportType.FRAUD_BY_FIC_CATEGORY]: {
    id: InternalReportType.FRAUD_BY_FIC_CATEGORY,
    title: "Category-wise Fraud Summary",
    description:
      "Fraud cases and amount involved across the selected fiscal year and the previous fiscal year.",
    tags: ["RBI"],
    group: InternalReportGroup.RBI_FRAUD_RETURNS,
    route: "/internal-reports/fraud-by-fic-category",
  },
};

export interface InternalReportGroupView {
  group: InternalReportGroup;
  label: string;
  reports: InternalReportConfigEntry[];
}

export const groupInternalReports = (
  ids: InternalReportType[]
): InternalReportGroupView[] => {
  const byGroup = new Map<InternalReportGroup, InternalReportConfigEntry[]>();

  ids.forEach((id) => {
    const config = INTERNAL_REPORT_CONFIG[id];
    if (!config) return;
    const reports = byGroup.get(config.group) ?? [];
    reports.push(config);
    byGroup.set(config.group, reports);
  });

  return Array.from(byGroup, ([group, reports]) => ({
    group,
    label: INTERNAL_REPORTS_GROUP_CONFIG[group].label,
    reports,
  })).sort(
    (a, b) =>
      INTERNAL_REPORTS_GROUP_CONFIG[a.group].order -
      INTERNAL_REPORTS_GROUP_CONFIG[b.group].order
  );
};
